var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("b-sidebar", {
        attrs: {
          id: "sidebar-add-new-event",
          "sidebar-class": "sidebar-lg",
          visible: _vm.isEventHandlerSidebarActive,
          "bg-variant": "white",
          width: "800px",
          shadow: "",
          backdrop: "",
          "no-header": "",
          right: ""
        },
        on: {
          change: function(val) {
            return _vm.$emit("update:is-event-handler-sidebar-active", val)
          }
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(ref) {
              var hide = ref.hide
              return [
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
                  },
                  [
                    _c("h5", { staticClass: "mb-0" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.canCreateEvent
                              ? _vm.eventLocal.id
                                ? "Alterar"
                                : "Adicionar"
                              : "Confirmar"
                          ) +
                          " Evento "
                      )
                    ]),
                    _c(
                      "div",
                      [
                        _vm.eventLocal.id
                          ? _c("feather-icon", {
                              directives: [
                                {
                                  name: "permission",
                                  rawName: "v-permission",
                                  value: "schedule_events.delete",
                                  expression: "'schedule_events.delete'"
                                }
                              ],
                              staticClass: "cursor-pointer",
                              attrs: { icon: "TrashIcon" },
                              on: {
                                click: function($event) {
                                  return _vm.$emit("remove-event", {
                                    calendar_id: _vm.eventLocal.id,
                                    schedule_id:
                                      _vm.eventLocal.extendedProps
                                        .scheduleEventId,
                                    hide: hide
                                  })
                                }
                              }
                            })
                          : _vm._e(),
                        _c("feather-icon", {
                          staticClass: "ml-1 cursor-pointer",
                          attrs: { icon: "XIcon", size: "16" },
                          on: { click: hide }
                        })
                      ],
                      1
                    )
                  ]
                ),
                _vm.authorName || _vm.authorEmail
                  ? _c(
                      "div",
                      { staticClass: "px-2 pt-1 flex flex-col gap-1" },
                      [
                        _c("label", { staticClass: "font" }, [
                          _vm._v("Agendado por")
                        ]),
                        _c(
                          "div",
                          {
                            staticClass:
                              "text-neutral flex flex-col border-grey border-solid border p-1 rounded"
                          },
                          [
                            _c("span", [
                              _vm._v(" " + _vm._s(_vm.authorName) + " ")
                            ]),
                            _c("span", { staticClass: "text-sm" }, [
                              _vm._v(" " + _vm._s(_vm.authorEmail) + " ")
                            ])
                          ]
                        )
                      ]
                    )
                  : _vm._e(),
                _c(
                  "validation-observer",
                  { ref: "refFormObserver" },
                  [
                    _c(
                      "b-form",
                      {
                        staticClass: "p-2",
                        attrs: { autocomplete: "off" },
                        on: {
                          submit: function($event) {
                            $event.preventDefault()
                            return _vm.onSubmit($event)
                          },
                          reset: function($event) {
                            $event.preventDefault()
                            return _vm.resetForm($event)
                          }
                        }
                      },
                      [
                        _c("validation-provider", {
                          attrs: {
                            name: _vm.$t("names.title"),
                            rules: "required"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(validationContext) {
                                  return [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          label: "Título",
                                          "label-for": "event-title"
                                        }
                                      },
                                      [
                                        _c("b-form-input", {
                                          attrs: {
                                            id: "event-title",
                                            autofocus: "",
                                            state: _vm.getValidationState(
                                              validationContext
                                            ),
                                            trim: "",
                                            placeholder: "Título do evento",
                                            disabled: !_vm.canCreateEvent
                                          },
                                          model: {
                                            value: _vm.eventLocal.title,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.eventLocal,
                                                "title",
                                                $$v
                                              )
                                            },
                                            expression: "eventLocal.title"
                                          }
                                        }),
                                        _c("b-form-invalid-feedback", [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                validationContext.errors[0]
                                              ) +
                                              " "
                                          )
                                        ])
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        }),
                        _c("validation-provider", {
                          attrs: {
                            name: _vm.$t("names.calendar"),
                            rules: "required"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(validationContext) {
                                  return [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          label: "Tipo de evento",
                                          "label-for": "calendar",
                                          state: _vm.getValidationState(
                                            validationContext
                                          )
                                        }
                                      },
                                      [
                                        _c(
                                          "b-form-radio-group",
                                          {
                                            attrs: {
                                              id: "calendar-select",
                                              name: "calendar",
                                              disabled: !_vm.canCreateEvent,
                                              stacked: ""
                                            },
                                            model: {
                                              value:
                                                _vm.eventLocal.extendedProps
                                                  .calendar,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.eventLocal.extendedProps,
                                                  "calendar",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "eventLocal.extendedProps.calendar"
                                            }
                                          },
                                          _vm._l(_vm.calendarTypes, function(
                                            calendarType
                                          ) {
                                            return _c(
                                              "b-form-radio",
                                              {
                                                key: calendarType.id,
                                                attrs: {
                                                  value: calendarType.id
                                                }
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "d-flex align-items-center"
                                                  },
                                                  [
                                                    _c("div", {
                                                      staticClass:
                                                        "rounded-circle d-inline-block mr-2",
                                                      style:
                                                        "height:12px;width:12px;background-color: " +
                                                        calendarType.color
                                                    }),
                                                    _c(
                                                      "span",
                                                      {
                                                        style:
                                                          "color: " +
                                                          calendarType.color
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            calendarType.name
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          }),
                                          1
                                        ),
                                        _c(
                                          "b-form-invalid-feedback",
                                          {
                                            attrs: {
                                              state: _vm.getValidationState(
                                                validationContext
                                              )
                                            }
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  validationContext.errors[0]
                                                ) +
                                                " "
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        }),
                        _vm.eventLocal.extendedProps.calendar !== 3
                          ? _c("validation-provider", {
                              attrs: {
                                name: "URL do Evento",
                                rules: "required|url"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(validationContext) {
                                      return [
                                        _c(
                                          "b-form-group",
                                          {
                                            attrs: {
                                              label: "URL Evento",
                                              "label-for": "event-url"
                                            }
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "flex flex-row gap-1"
                                              },
                                              [
                                                _c("b-form-input", {
                                                  staticClass: "flex-grow-0",
                                                  attrs: {
                                                    id: "event-url",
                                                    type: "url",
                                                    state: _vm.getValidationState(
                                                      validationContext
                                                    ),
                                                    placeholder: "",
                                                    trim: "",
                                                    disabled: !_vm.canCreateEvent
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.eventLocal
                                                        .extendedProps.eventUrl,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.eventLocal
                                                          .extendedProps,
                                                        "eventUrl",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "eventLocal.extendedProps.eventUrl"
                                                  }
                                                }),
                                                _vm.event.extendedProps.eventUrl
                                                  ? _c(
                                                      "b-button",
                                                      {
                                                        directives: [
                                                          {
                                                            name: "clipboard",
                                                            rawName:
                                                              "v-clipboard:copy",
                                                            value:
                                                              _vm.eventLocal
                                                                .extendedProps
                                                                .eventUrl,
                                                            expression:
                                                              "eventLocal.extendedProps.eventUrl",
                                                            arg: "copy"
                                                          },
                                                          {
                                                            name: "clipboard",
                                                            rawName:
                                                              "v-clipboard:success",
                                                            value: function() {
                                                              _vm.$toast(
                                                                "Copiado para a área de transferência!",
                                                                {
                                                                  type:
                                                                    "success",
                                                                  position:
                                                                    "top-right",
                                                                  duration: 3000
                                                                }
                                                              )
                                                            },
                                                            expression:
                                                              "() => {\n                    $toast('Copiado para a área de transferência!', {\n                      type: 'success',\n                      position: 'top-right',\n                      duration: 3000\n                    })\n                  }",
                                                            arg: "success"
                                                          },
                                                          {
                                                            name: "clipboard",
                                                            rawName:
                                                              "v-clipboard:error",
                                                            value: function() {
                                                              _vm.$toast(
                                                                "Não foi possível copiar para a área de transferência!",
                                                                {
                                                                  type: "error",
                                                                  position:
                                                                    "top-right",
                                                                  duration: 3000
                                                                }
                                                              )
                                                            },
                                                            expression:
                                                              "() => {\n                    $toast('Não foi possível copiar para a área de transferência!', {\n                      type: 'error',\n                      position: 'top-right',\n                      duration: 3000\n                    })\n                  }",
                                                            arg: "error"
                                                          }
                                                        ],
                                                        staticClass:
                                                          "flex-grow w-1/6",
                                                        attrs: {
                                                          size: "sm",
                                                          variant:
                                                            "outline-primary"
                                                        }
                                                      },
                                                      [
                                                        _c("b-icon-clipboard"),
                                                        !_vm.isSmallScreen()
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "text-base"
                                                              },
                                                              [_vm._v("Copiar")]
                                                            )
                                                          : _vm._e()
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm.event.extendedProps.eventUrl
                                                  ? _c(
                                                      "b-button",
                                                      {
                                                        staticClass:
                                                          "flex items-center flex-grow w-1/6",
                                                        attrs: {
                                                          size: "sm",
                                                          href:
                                                            _vm.eventLocal
                                                              .extendedProps
                                                              .eventUrl,
                                                          target: "_blank",
                                                          variant: "link"
                                                        }
                                                      },
                                                      [
                                                        _c("b-icon-link45deg"),
                                                        !_vm.isSmallScreen()
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "text-base"
                                                              },
                                                              [_vm._v("Abrir")]
                                                            )
                                                          : _vm._e()
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e()
                                              ],
                                              1
                                            ),
                                            _c(
                                              "b-form-invalid-feedback",
                                              {
                                                attrs: {
                                                  state: _vm.getValidationState(
                                                    validationContext
                                                  )
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      validationContext
                                                        .errors[0]
                                                    ) +
                                                    " "
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            })
                          : _vm._e(),
                        _c(
                          "b-card",
                          {
                            ref: "divStartDate",
                            staticClass: "shadow-none",
                            attrs: {
                              "border-variant": "primary",
                              title: "Sugestões datas",
                              "bg-variant": "transparent",
                              id: "divStartDate"
                            }
                          },
                          [
                            _c(
                              "b-card-text",
                              [
                                _vm.canCreateEvent
                                  ? _c(
                                      "b-row",
                                      [
                                        _c(
                                          "b-col",
                                          { attrs: { md: "6" } },
                                          [
                                            _c("validation-provider", {
                                              attrs: { name: "Start Date" },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function(
                                                      validationContext
                                                    ) {
                                                      return [
                                                        _c(
                                                          "b-form-group",
                                                          {
                                                            attrs: {
                                                              label:
                                                                "Data Início",
                                                              "label-for":
                                                                "start-date",
                                                              state: _vm.getValidationState(
                                                                validationContext
                                                              )
                                                            }
                                                          },
                                                          [
                                                            _c("flat-pickr", {
                                                              staticClass:
                                                                "form-control",
                                                              attrs: {
                                                                config:
                                                                  _vm.config
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm.eventLocal
                                                                    .start_formatted,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.eventLocal,
                                                                    "start_formatted",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "eventLocal.start_formatted"
                                                              }
                                                            }),
                                                            _c(
                                                              "b-form-invalid-feedback",
                                                              {
                                                                attrs: {
                                                                  state: _vm.getValidationState(
                                                                    validationContext
                                                                  )
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      validationContext
                                                                        .errors[0]
                                                                    ) +
                                                                    " "
                                                                )
                                                              ]
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                true
                                              )
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "b-col",
                                          { attrs: { md: "6" } },
                                          [
                                            _c("validation-provider", {
                                              attrs: {
                                                name: "Duração",
                                                rules: "min:1|integer"
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function(
                                                      validationContext
                                                    ) {
                                                      return [
                                                        _c(
                                                          "b-form-group",
                                                          {
                                                            attrs: {
                                                              label:
                                                                "Duração (Horas)",
                                                              "label-for":
                                                                "duration",
                                                              state: _vm.getValidationState(
                                                                validationContext
                                                              )
                                                            }
                                                          },
                                                          [
                                                            _c("b-form-input", {
                                                              attrs: {
                                                                id: "duration",
                                                                state: validationContext.validated
                                                                  ? validationContext.valid
                                                                  : null,
                                                                type: "number"
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm.eventLocal
                                                                    .duration,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.eventLocal,
                                                                    "duration",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "eventLocal.duration"
                                                              }
                                                            }),
                                                            _c(
                                                              "b-form-invalid-feedback",
                                                              {
                                                                attrs: {
                                                                  state: _vm.getValidationState(
                                                                    validationContext
                                                                  )
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      validationContext
                                                                        .errors[0]
                                                                    ) +
                                                                    " "
                                                                )
                                                              ]
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                true
                                              )
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm.canCreateEvent
                                  ? _c(
                                      "b-row",
                                      [
                                        _c(
                                          "b-col",
                                          [
                                            _c(
                                              "b-button",
                                              {
                                                directives: [
                                                  {
                                                    name: "ripple",
                                                    rawName: "v-ripple.400",
                                                    value:
                                                      "rgba(255, 255, 255, 0.15)",
                                                    expression:
                                                      "'rgba(255, 255, 255, 0.15)'",
                                                    modifiers: { "400": true }
                                                  }
                                                ],
                                                staticClass: "float-right",
                                                attrs: { variant: "primary" },
                                                on: {
                                                  click: _vm.addSuggestionDate
                                                }
                                              },
                                              [_vm._v(" Adicionar data ")]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _c(
                                  "b-row",
                                  { staticClass: "mt-2" },
                                  [
                                    _c(
                                      "b-col",
                                      [
                                        _c("date-suggestion-table", {
                                          attrs: {
                                            "show-guest-statistics":
                                              _vm.canCreateEvent,
                                            "can-participate": _vm.userInvited,
                                            "can-remove": _vm.canCreateEvent,
                                            items: _vm.suggestionDateList,
                                            "re-render-on-actions": ""
                                          },
                                          on: {
                                            "clicked-guest-statistics":
                                              _vm.openSuggestionGuestStatisticsModal,
                                            "clicked-remove":
                                              _vm.removeSuggestionDate,
                                            "clicked-confirm":
                                              _vm.confirmSchedule,
                                            "clicked-disconfirm":
                                              _vm.disconfirmSchedule
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "after",
                                                fn: function() {
                                                  return [
                                                    _c("div", {
                                                      staticClass:
                                                        "w-full border-grey border-solid border-l-0 border-r-0 border-b-0 border-t my-2"
                                                    }),
                                                    _c(
                                                      "b-overlay",
                                                      {
                                                        attrs: {
                                                          rounded: "",
                                                          opacity: "0.50"
                                                        },
                                                        scopedSlots: _vm._u(
                                                          [
                                                            {
                                                              key: "overlay",
                                                              fn: function() {
                                                                return [
                                                                  _c("b", [
                                                                    _vm._v(
                                                                      "Não é possível editar este parâmetro."
                                                                    )
                                                                  ])
                                                                ]
                                                              },
                                                              proxy: true
                                                            }
                                                          ],
                                                          null,
                                                          true
                                                        )
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "flex flex-row gap-2"
                                                          },
                                                          [
                                                            _c(
                                                              "b-form-group",
                                                              {
                                                                attrs: {
                                                                  label:
                                                                    "Repetir",
                                                                  "label-for":
                                                                    "repeat"
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "b-form-select",
                                                                  {
                                                                    attrs: {
                                                                      id:
                                                                        "repeat"
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .eventLocal
                                                                          .extendedProps
                                                                          .repeat,
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm
                                                                            .eventLocal
                                                                            .extendedProps,
                                                                          "repeat",
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "eventLocal.extendedProps.repeat"
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "b-form-select-option",
                                                                      {
                                                                        attrs: {
                                                                          value: null
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "Nunca"
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "b-form-select-option",
                                                                      {
                                                                        attrs: {
                                                                          value:
                                                                            "daily"
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "Diariamente"
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "b-form-select-option",
                                                                      {
                                                                        attrs: {
                                                                          value:
                                                                            "weekly"
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "Semanalmente"
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "b-form-select-option",
                                                                      {
                                                                        attrs: {
                                                                          value:
                                                                            "biweekly"
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "Quinzenalmente"
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "b-form-select-option",
                                                                      {
                                                                        attrs: {
                                                                          value:
                                                                            "monthly"
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "Mensalmente"
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "b-form-select-option",
                                                                      {
                                                                        attrs: {
                                                                          value:
                                                                            "yearly"
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "Anualmente"
                                                                        )
                                                                      ]
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              ],
                                                              1
                                                            ),
                                                            _c(
                                                              "validation-provider",
                                                              {
                                                                attrs: {
                                                                  name:
                                                                    "[Repetir] Até"
                                                                },
                                                                scopedSlots: _vm._u(
                                                                  [
                                                                    {
                                                                      key:
                                                                        "default",
                                                                      fn: function(
                                                                        validationContext
                                                                      ) {
                                                                        return [
                                                                          _vm
                                                                            .eventLocal
                                                                            .extendedProps
                                                                            .repeat
                                                                            ? _c(
                                                                                "b-form-group",
                                                                                {
                                                                                  attrs: {
                                                                                    label:
                                                                                      "Até",
                                                                                    "label-for":
                                                                                      "repeat_until"
                                                                                  }
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "flat-pickr",
                                                                                    {
                                                                                      staticClass:
                                                                                        "form-control",
                                                                                      attrs: {
                                                                                        id:
                                                                                          "repeat_until",
                                                                                        config:
                                                                                          _vm.config
                                                                                      },
                                                                                      model: {
                                                                                        value:
                                                                                          _vm
                                                                                            .eventLocal
                                                                                            .extendedProps
                                                                                            .repeat_until,
                                                                                        callback: function(
                                                                                          $$v
                                                                                        ) {
                                                                                          _vm.$set(
                                                                                            _vm
                                                                                              .eventLocal
                                                                                              .extendedProps,
                                                                                            "repeat_until",
                                                                                            $$v
                                                                                          )
                                                                                        },
                                                                                        expression:
                                                                                          "eventLocal.extendedProps.repeat_until"
                                                                                      }
                                                                                    }
                                                                                  ),
                                                                                  _c(
                                                                                    "b-form-invalid-feedback",
                                                                                    {
                                                                                      attrs: {
                                                                                        state: _vm.getValidationState(
                                                                                          validationContext
                                                                                        )
                                                                                      }
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        " " +
                                                                                          _vm._s(
                                                                                            validationContext
                                                                                              .errors[0]
                                                                                          ) +
                                                                                          " "
                                                                                      )
                                                                                    ]
                                                                                  )
                                                                                ],
                                                                                1
                                                                              )
                                                                            : _vm._e()
                                                                        ]
                                                                      }
                                                                    }
                                                                  ],
                                                                  null,
                                                                  true
                                                                )
                                                              }
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                },
                                                proxy: true
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm.canCreateEvent
                          ? _c(
                              "b-card",
                              {
                                staticClass: "shadow-none",
                                attrs: {
                                  "border-variant": "primary",
                                  title: "Lembretes",
                                  "bg-variant": "transparent"
                                }
                              },
                              [
                                _c("b-card-text", [
                                  _c(
                                    "div",
                                    {
                                      key: _vm.reminders_key,
                                      staticClass: "reminder-items"
                                    },
                                    [
                                      _vm._l(
                                        _vm.eventLocal.extendedProps.reminders,
                                        function(reminder, i) {
                                          return _c("calendar-reminder-item", {
                                            key: i,
                                            attrs: {
                                              reminder: reminder,
                                              idx: i,
                                              disabled: !_vm.canCreateEvent
                                            },
                                            on: {
                                              input: _vm.updateReminder,
                                              remove: _vm.removeReminder
                                            }
                                          })
                                        }
                                      ),
                                      _vm.eventLocal.extendedProps.reminders &&
                                      _vm.eventLocal.extendedProps.reminders
                                        .length < 5 &&
                                      _vm.canCreateEvent
                                        ? _c("calendar-reminder-item", {
                                            key: null,
                                            on: { input: _vm.addReminder }
                                          })
                                        : _vm._e()
                                    ],
                                    2
                                  )
                                ])
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "b-card",
                          {
                            ref: "divGuest",
                            staticClass: "shadow-none",
                            attrs: {
                              "border-variant": "primary",
                              title: "Convidados",
                              "bg-variant": "transparent",
                              id: "divGuest"
                            }
                          },
                          [
                            _c(
                              "b-card-text",
                              [
                                _vm.canCreateEvent
                                  ? _c(
                                      "b-form-group",
                                      [
                                        _c(
                                          "b-form-radio-group",
                                          {
                                            attrs: {
                                              "aria-controls":
                                                "ex-disabled-readonly"
                                            },
                                            model: {
                                              value: _vm.userType,
                                              callback: function($$v) {
                                                _vm.userType = $$v
                                              },
                                              expression: "userType"
                                            }
                                          },
                                          [
                                            _c(
                                              "b-form-radio",
                                              { attrs: { value: "user" } },
                                              [_vm._v(" Usuário ")]
                                            ),
                                            _c(
                                              "b-form-radio",
                                              {
                                                attrs: { value: "legal_entity" }
                                              },
                                              [_vm._v(" Pessoa Jurídica ")]
                                            ),
                                            _c(
                                              "b-form-radio",
                                              {
                                                attrs: {
                                                  value: "external_entity"
                                                }
                                              },
                                              [_vm._v(" Contato ")]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm.canCreateEvent
                                  ? _c(
                                      "b-row",
                                      { key: _vm.selectionKey },
                                      [
                                        _vm.canCreateEvent
                                          ? _c(
                                              "b-col",
                                              [
                                                _vm.userType == "user"
                                                  ? _c("select-suggestion", {
                                                      key: _vm.selectedUser,
                                                      ref: "userSelect",
                                                      attrs: {
                                                        column: "name,email",
                                                        model: "User",
                                                        label: "Usuário",
                                                        appendClearOption: true,
                                                        placeholderText:
                                                          "Digite o nome ou e-mail do usuário",
                                                        itemTextFormat: function(
                                                          model
                                                        ) {
                                                          return (
                                                            model.name +
                                                            " <br/><div class='text-sm'>" +
                                                            model.email +
                                                            "<div>"
                                                          )
                                                        }
                                                      },
                                                      model: {
                                                        value: _vm.selectedUser,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.selectedUser = $$v
                                                        },
                                                        expression:
                                                          "selectedUser"
                                                      }
                                                    })
                                                  : _vm.userType ==
                                                    "legal_entity"
                                                  ? _c("select-suggestion", {
                                                      key: _vm.selectedUser,
                                                      ref: "legalEntitySelect",
                                                      attrs: {
                                                        column:
                                                          "company_name,trading_name,cnpj",
                                                        model: "LegalEntity",
                                                        label:
                                                          "Pessoa Jurídica",
                                                        appendClearOption: true,
                                                        placeholderText:
                                                          "Digite o nome ou cnpj da pessoa jurídica",
                                                        itemTextFormat:
                                                          _vm.legalEntityItemTextFormat
                                                      },
                                                      on: {
                                                        "selected-model":
                                                          _vm.selectedLegalEntityGuest
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.selectedLegalEntity,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.selectedLegalEntity = $$v
                                                        },
                                                        expression:
                                                          "selectedLegalEntity"
                                                      }
                                                    })
                                                  : _vm.userType ==
                                                    "external_entity"
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "flex gap-2 grid grid-cols-2"
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          [
                                                            _c(
                                                              "label",
                                                              {
                                                                attrs: {
                                                                  for:
                                                                    "entity_name"
                                                                }
                                                              },
                                                              [_vm._v("Nome")]
                                                            ),
                                                            _c("b-form-input", {
                                                              attrs: {
                                                                id:
                                                                  "entity_name",
                                                                type: "text",
                                                                placeholder:
                                                                  "Nome"
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .externalEntity
                                                                    .name,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.externalEntity,
                                                                    "name",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "externalEntity.name"
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "div",
                                                          [
                                                            _c(
                                                              "label",
                                                              {
                                                                attrs: {
                                                                  for:
                                                                    "entity_email"
                                                                }
                                                              },
                                                              [_vm._v("Email")]
                                                            ),
                                                            _c("b-form-input", {
                                                              attrs: {
                                                                id:
                                                                  "entity_email",
                                                                type: "email",
                                                                placeholder:
                                                                  "Email"
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .externalEntity
                                                                    .email,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.externalEntity,
                                                                    "email",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "externalEntity.email"
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm.userType == "contact_list"
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "flex flex-row gap-4 items-end"
                                                      },
                                                      [
                                                        _c(
                                                          "select-suggestion",
                                                          {
                                                            ref:
                                                              "contactListSuggestion",
                                                            staticClass:
                                                              "w-full",
                                                            attrs: {
                                                              column: "name",
                                                              model:
                                                                "ContactList",
                                                              label:
                                                                "Lista de Contato",
                                                              appendClearOption: true,
                                                              placeholderText:
                                                                "Digite o nome da lista.",
                                                              itemTextFormat: function(
                                                                val
                                                              ) {
                                                                return val.name
                                                              }
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.selectedContactList,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.selectedContactList = $$v
                                                              },
                                                              expression:
                                                                "selectedContactList"
                                                            }
                                                          }
                                                        ),
                                                        _vm.selectedContactList
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "flex-grow"
                                                              },
                                                              [
                                                                _c(
                                                                  "b-button",
                                                                  {
                                                                    directives: [
                                                                      {
                                                                        name:
                                                                          "ripple",
                                                                        rawName:
                                                                          "v-ripple.400",
                                                                        value:
                                                                          "rgba(255, 255, 255, 0.15)",
                                                                        expression:
                                                                          "'rgba(255, 255, 255, 0.15)'",
                                                                        modifiers: {
                                                                          "400": true
                                                                        }
                                                                      },
                                                                      {
                                                                        name:
                                                                          "tooltip",
                                                                        rawName:
                                                                          "v-tooltip",
                                                                        value: {
                                                                          content:
                                                                            "Retira do evento todos os convidados que fazem parte da lista selecionada.",
                                                                          duration: {
                                                                            show: 100,
                                                                            hide: 100
                                                                          }
                                                                        },
                                                                        expression:
                                                                          "{\n                          content: 'Retira do evento todos os convidados que fazem parte da lista selecionada.',\n                          duration: {show: 100, hide: 100}\n                        }"
                                                                      }
                                                                    ],
                                                                    staticClass:
                                                                      "flex flex-row",
                                                                    attrs: {
                                                                      variant:
                                                                        "danger"
                                                                    },
                                                                    on: {
                                                                      click: function(
                                                                        $event
                                                                      ) {
                                                                        return _vm.removeContactList(
                                                                          _vm.selectedContactList
                                                                        )
                                                                      }
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "feather-icon",
                                                                      {
                                                                        staticClass:
                                                                          "mr-50",
                                                                        attrs: {
                                                                          icon:
                                                                            "TrashIcon"
                                                                        }
                                                                      }
                                                                    ),
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "align-middle"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "Remover"
                                                                        )
                                                                      ]
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          : _vm._e()
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e()
                                              ],
                                              1
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm.canCreateEvent
                                  ? _c(
                                      "b-row",
                                      {
                                        key: _vm.selectionKey,
                                        attrs: { "align-v": "end" }
                                      },
                                      [
                                        _c(
                                          "b-col",
                                          {
                                            staticClass:
                                              "flex gap-1 justify-end pt-1"
                                          },
                                          [
                                            _vm.userType == "external_entity"
                                              ? _c(
                                                  "b-button",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "ripple",
                                                        rawName: "v-ripple.400",
                                                        value:
                                                          "rgba(255, 255, 255, 0.15)",
                                                        expression:
                                                          "'rgba(255, 255, 255, 0.15)'",
                                                        modifiers: {
                                                          "400": true
                                                        }
                                                      }
                                                    ],
                                                    staticClass: "px-1",
                                                    attrs: {
                                                      variant: "primary"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.$bvModal.show(
                                                          "search-contact"
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [_c("b-icon-search")],
                                                  1
                                                )
                                              : _vm._e(),
                                            _c(
                                              "b-button",
                                              {
                                                directives: [
                                                  {
                                                    name: "ripple",
                                                    rawName: "v-ripple.400",
                                                    value:
                                                      "rgba(255, 255, 255, 0.15)",
                                                    expression:
                                                      "'rgba(255, 255, 255, 0.15)'",
                                                    modifiers: { "400": true }
                                                  }
                                                ],
                                                attrs: { variant: "primary" },
                                                on: { click: _vm.addGuest }
                                              },
                                              [
                                                _c("feather-icon", {
                                                  staticClass: "mr-50",
                                                  attrs: { icon: "PlusIcon" }
                                                }),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "align-middle"
                                                  },
                                                  [_vm._v("Adicionar")]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm.showOrganizationalUnit() &&
                                !_vm.isUserSelection &&
                                _vm.canCreateEvent &&
                                _vm.userType !== "external_entity" &&
                                _vm.userType !== "contact_list"
                                  ? _c(
                                      "b-row",
                                      {
                                        key: _vm.selectionKey,
                                        staticClass: "mt-2",
                                        attrs: { "align-v": "end" }
                                      },
                                      [
                                        _c(
                                          "b-col",
                                          { attrs: { md: "9" } },
                                          [
                                            _c(
                                              "b-form-group",
                                              {
                                                staticStyle: {
                                                  "margin-bottom": "unset"
                                                },
                                                attrs: {
                                                  label:
                                                    "Unidade Organizacional",
                                                  "label-for":
                                                    "add-organization-units"
                                                }
                                              },
                                              [
                                                _c(
                                                  "v-select",
                                                  {
                                                    attrs: {
                                                      multiple: "",
                                                      "close-on-select": false,
                                                      options:
                                                        _vm.eventLocal
                                                          .organizationalUnitsList,
                                                      label: "label",
                                                      "input-id":
                                                        "add-organization-units"
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.selectedOrganizationalUnits,
                                                      callback: function($$v) {
                                                        _vm.selectedOrganizationalUnits = $$v
                                                      },
                                                      expression:
                                                        "selectedOrganizationalUnits"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        attrs: {
                                                          slot: "no-options"
                                                        },
                                                        slot: "no-options"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Nenhuma unidade vinculada às instituições adicionadas!"
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _c(
                                          "b-col",
                                          { attrs: { md: "3" } },
                                          [
                                            _c(
                                              "b-button",
                                              {
                                                directives: [
                                                  {
                                                    name: "ripple",
                                                    rawName: "v-ripple.400",
                                                    value:
                                                      "rgba(255, 255, 255, 0.15)",
                                                    expression:
                                                      "'rgba(255, 255, 255, 0.15)'",
                                                    modifiers: { "400": true }
                                                  }
                                                ],
                                                staticClass: "float-right",
                                                attrs: { variant: "primary" },
                                                on: { click: _vm.addUnitGuest }
                                              },
                                              [
                                                _c("feather-icon", {
                                                  staticClass: "mr-50",
                                                  attrs: { icon: "PlusIcon" }
                                                }),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "align-middle"
                                                  },
                                                  [_vm._v("Adicionar")]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _c(
                                  "b-row",
                                  { staticClass: "mt-2" },
                                  [
                                    _c(
                                      "b-col",
                                      [
                                        _c("guests-table", {
                                          attrs: {
                                            guests:
                                              _vm.eventLocal.extendedProps
                                                .guests,
                                            "show-actions": _vm.canCreateEvent
                                          },
                                          on: {
                                            "open-justifications":
                                              _vm.openJustificationsModal,
                                            "remove-guest": _vm.removeGuest
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c("h4", [_vm._v("Descrição")]),
                        _c("simple-editor", {
                          key: _vm.editorDescriptionKey,
                          ref: "refEditorDescription",
                          staticClass: "border-primary mb-2",
                          model: {
                            value: _vm.eventLocal.extendedProps.description,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.eventLocal.extendedProps,
                                "description",
                                $$v
                              )
                            },
                            expression: "eventLocal.extendedProps.description"
                          }
                        }),
                        _c(
                          "b-overlay",
                          {
                            attrs: { blur: "2px" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "overlay",
                                  fn: function() {
                                    return [
                                      _c("span", { staticClass: "font-bold" }, [
                                        _vm._v(
                                          " Salve este agendamento para adicionar anexos. "
                                        )
                                      ])
                                    ]
                                  },
                                  proxy: true
                                }
                              ],
                              null,
                              true
                            )
                          },
                          [
                            _c(
                              "b-card",
                              {
                                staticClass: "shadow-none",
                                attrs: {
                                  "border-variant": "primary",
                                  title: "Anexos",
                                  "bg-variant": "transparent"
                                }
                              },
                              [
                                _c(
                                  "b-card-text",
                                  [
                                    _c("schedule-event-attachments", {
                                      key: _vm.attachmentRenderKey,
                                      attrs: { id: _vm.eventId, listed: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "meta",
                                            fn: function(dropzone) {
                                              return [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.connectDropzone(
                                                        dropzone
                                                      )
                                                    ) +
                                                    " "
                                                )
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        true
                                      ),
                                      model: {
                                        value: _vm.filesAdded,
                                        callback: function($$v) {
                                          _vm.filesAdded = $$v
                                        },
                                        expression: "filesAdded"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "d-flex mt-2" },
                          [
                            _vm.canCreateEvent
                              ? _c(
                                  "b-button",
                                  {
                                    directives: [
                                      {
                                        name: "ripple",
                                        rawName: "v-ripple.400",
                                        value: "rgba(255, 255, 255, 0.15)",
                                        expression:
                                          "'rgba(255, 255, 255, 0.15)'",
                                        modifiers: { "400": true }
                                      }
                                    ],
                                    staticClass: "mr-2",
                                    attrs: {
                                      variant: "primary",
                                      type: "submit"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.eventLocal.id
                                            ? "Atualizar"
                                            : "Adicionar "
                                        ) +
                                        " "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            }
          }
        ])
      }),
      _c("suggestion-guest-justifications", {
        attrs: {
          show: _vm.showJustificationsPopup,
          items: _vm.justificationItems,
          guest: _vm.justificationGuest
        },
        on: {
          "update:show": function($event) {
            _vm.showJustificationsPopup = $event
          }
        }
      }),
      _c("suggestion-guest-statistics", {
        attrs: {
          show: _vm.showGuestStatisticsPopup,
          "schedule-suggestion": _vm.suggestionForStatistics,
          "event-guests": _vm.eventLocal.extendedProps.guests,
          event: _vm.eventLocal
        },
        on: {
          "update:show": function($event) {
            _vm.showGuestStatisticsPopup = $event
          },
          "open-justifications": _vm.openJustificationsModal
        }
      }),
      _c("calendar-contact-popup", {
        on: { selected: _vm.addContactListGuest }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }